import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const BLOCKCHAIN_API_URL = 'https://api.blockchain.info'

export const ENABLED_ASSETS = {
  __proto__: null,
  aave_eth: assets.aave?.name,
  ada_ada: assets.cardano?.name,
  algo_algo: assets.algorand?.name,
  ape_eth: assets.ape?.name,
  bch_bch: assets.bcash?.name,
  btc_btc: assets.bitcoin?.name,
  chz_eth: assets.chiliz?.name,
  comp_eth: assets.compound?.name,
  crv_eth: assets.crv?.name,
  dai_eth: assets.mcd?.name,
  doge_doge: assets.dogecoin?.name,
  dot_dot: assets.polkadot?.name,
  etc_etc: assets.ethereumclassic?.name,
  eth_eth: assets.ethereum?.name,
  link_eth: assets.chainlink?.name,
  ltc_ltc: assets.litecoin?.name,
  snx_eth: assets.snx?.name,
  sol_sol: assets.solana?.name,
  sushi_eth: assets.sushiswap?.name,
  trx_trx: assets.tronmainnet?.name,
  uni_eth: assets.uniswap?.name,
  usdc_eth: assets.usdcoin?.name,
  usdt_eth: assets.tetherusd?.name,
  wbtc_eth: assets.wbtc?.name,
  xlm_xlm: assets.stellar?.name,
  xrp_xrp: assets.ripple?.name,
  yfi_eth: assets.yfi?.name,
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  apple_pay: 'APPLE_PAY',
  card: 'CARD',
  google_pay: 'GOOGLE_PAY',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.apple_pay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.apple_pay,
      type: PAYMENT_METHOD_TYPES.apple_pay,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.card,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.card,
      type: PAYMENT_METHOD_TYPES.card,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.google_pay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.google_pay,
      type: PAYMENT_METHOD_TYPES.google_pay,
    }),
  ],
])

export const ORDER_STATUSES = {
  __proto__: null,
  completed: 'COMPLETED',
  failed: 'FAILED',
  pending: 'PENDING',
  withdrawing: 'WITHDRAWING',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.completed],
  failed: [ORDER_STATUSES.failed],
  'in-progress': [ORDER_STATUSES.pending, ORDER_STATUSES.withdrawing],
}
